/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const WalletTransactionType = {
  AccountFunding: "account-funding",
  AchReversal: "ach-reversal",
  AutoSweep: "auto-sweep",
  CardPayment: "card-payment",
  CardDecline: "card-decline",
  CardReversal: "card-reversal",
  CashOut: "cash-out",
  Dispute: "dispute",
  DisputeReversal: "dispute-reversal",
  FacilitatorFee: "facilitator-fee",
  IssuingRefund: "issuing-refund",
  IssuingTransaction: "issuing-transaction",
  IssuingTransactionAdjustment: "issuing-transaction-adjustment",
  IssuingAuthHold: "issuing-auth-hold",
  IssuingAuthRelease: "issuing-auth-release",
  IssuingDecline: "issuing-decline",
  MoovFee: "moov-fee",
  Payment: "payment",
  Payout: "payout",
  Refund: "refund",
  RefundFailure: "refund-failure",
  RtpFailure: "rtp-failure",
  TopUp: "top-up",
  WalletTransfer: "wallet-transfer",
  Adjustment: "adjustment",
  FeeRevenue: "fee-revenue",
  Residual: "residual",
} as const;
export type WalletTransactionType = ClosedEnum<typeof WalletTransactionType>;

/** @internal */
export const WalletTransactionType$inboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionType
> = z.nativeEnum(WalletTransactionType);
/** @internal */
export const WalletTransactionType$outboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionType
> = WalletTransactionType$inboundSchema;
